module.exports = __webpack_public_path__ + "35fdfe886315744d5f87f9447f2e13c5.png";